import {Component} from '@angular/core';
import {UserService} from '@account/shared/users/services/user.service';
import {FormHandler} from "@iw-shared/form/models/form-handler";
import {faSignIn} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'page-authentication-password-lost',
  templateUrl: './page-authentication-password-lost.component.html',
  styleUrls: ['./page-authentication-password-lost.component.scss']
})
export class PageAuthenticationPasswordLostComponent {
  sentTo: string = '';

  formHandler: FormHandler = new FormHandler();

  errorMessage: string = '';

  constructor(private userService: UserService) {

  }
  sendEmailVerificationLostPassword(params: { username: string }) {
    this.formHandler.setFormStatus({formStatus: 'loading'});
    this.userService.sendEmailVerificationLostPassword(params.username).subscribe(
      r => {
        if (r.result?.accountBackendUserEmailVerification.data.email) {
          this.formHandler.setFormStatus({formStatus: 'success'});
          this.sentTo = r.result?.accountBackendUserEmailVerification.data.email;
        } else {
          if(r.error?.message){
            this.errorMessage = r.error.message;
          }
          this.formHandler.setFormStatus({formStatus: 'submitForm'});
        }

      }
    );
  }

  protected readonly faSignIn = faSignIn;
}
